import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.dom-exception.stack.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "m-img-cutter",
  inject: ["reload"],
  props: {
    crossOrigin: {
      // 是否设置图片跨域
      type: Boolean,
      default: false,
      required: false
    },
    crossOriginHeader: {
      // 是否设置图片跨域
      type: String,
      default: "*",
      required: false
    },
    label: {
      // 按钮文字
      type: String,
      default: "选择图片",
      required: false
    },
    isModal: {
      // 是否已弹窗形式展示
      type: Boolean,
      default: false,
      required: false
    },
    lockScroll: {
      // 是否在弹窗出现时锁定body
      type: Boolean,
      default: true,
      required: false
    },
    showChooseBtn: {
      // 是否显示选择图片按钮 如果需要兼容IE9 则将此参数改为false
      type: Boolean,
      default: true,
      required: false
    },
    // boxWidth: {
    //   // 裁剪窗口高度
    //   type: Number,
    //   default: 350,
    //   required: false,
    // },
    // boxHeight: {
    //   // 裁剪窗口高度
    //   type: Number,
    //   default: 350,
    //   required: false,
    // },
    cutWidth: {
      // 默认裁剪宽度
      type: Number,
      default: 200,
      required: false
    },
    cutHeight: {
      // 默认裁剪高度
      type: Number,
      default: 200,
      required: false
    },
    rate: {
      // 按比例裁剪
      type: String,
      default: null,
      required: false
    },
    tool: {
      // 是否显示工具栏
      type: Boolean,
      default: true,
      required: false
    },
    toolBgc: {
      // 工具栏背景色
      type: String,
      default: "#fff",
      required: false
    },
    imgMove: {
      // 能否拖动图片
      type: Boolean,
      default: true,
      required: false
    },
    sizeChange: {
      // 能否调整裁剪尺寸
      type: Boolean,
      default: true,
      required: false
    },
    originalGraph: {
      // 是否为原图裁剪
      type: Boolean,
      default: false,
      required: false
    },
    moveAble: {
      // 能否调整裁剪区域位置
      type: Boolean,
      default: true,
      required: false
    },
    previewMode: {
      // 裁剪过程中是否返回裁剪结果 裁剪原图卡顿时将此项设置为false
      type: Boolean,
      default: true,
      required: false
    },
    CuttingOriginal: {
      // 是否裁剪原图
      type: Boolean,
      default: false,
      required: false
    },
    WatermarkText: {
      // 水印文字
      type: String,
      default: "",
      required: false
    },
    WatermarkTextFont: {
      // 水印文字样式
      type: String,
      default: "12px Sans-serif",
      required: false
    },
    WatermarkTextColor: {
      // 水印文字颜色
      type: String,
      default: "#fff",
      required: false
    },
    WatermarkTextX: {
      // 水印横向位置
      type: Number,
      default: 0.95,
      required: false
    },
    WatermarkTextY: {
      // 水印纵向位置
      type: Number,
      default: 0.95,
      required: false
    },
    smallToUpload: {
      // 选择的图片宽高均小于裁剪宽高度时候直接上传原图
      type: Boolean,
      default: false,
      required: false
    },
    saveCutPosition: {
      // 是否保存上一次裁剪位置
      type: Boolean,
      default: false,
      required: false
    },
    scaleAble: {
      // 是否允许缩放图片
      type: Boolean,
      default: true,
      required: false
    },
    index: {
      // 自定义参数 返回结果时会带入此值
      default: null,
      required: false
    },
    toolBoxOverflow: {
      // 是否允许裁剪框超出图片
      type: Boolean,
      default: true,
      required: false
    },
    DoNotDisplayCopyright: {
      type: Boolean,
      default: false,
      required: false
    },
    // 裁剪后的图片质量
    quality: {
      type: Number,
      default: 1,
      required: false
    },
    accept: {
      type: String,
      default: "image/gif, image/jpeg ,image/png",
      required: false
    }
  },
  model: ["label", "boxWidth", "boxHeight", "rate", "tool", "DoNotDisplayCopyright"],
  data() {
    let toolBoxWidth, toolBoxHeight;
    toolBoxWidth = this.boxWidth / 2;
    toolBoxHeight = this.boxHeight / 2;
    return {
      fileType: "",
      version: "",
      fileName: "",
      cutImageObj: null,
      onPrintImgTimmer: null,
      toolBoxPosition: {
        x: 0,
        y: 0
      },
      drawImg: {
        img: null,
        //规定要使用的图像、画布或视频
        sx: 0,
        //开始剪切的 x 坐标位置
        sy: 0,
        //开始剪切的 y 坐标位置
        swidth: 0,
        //被剪切图像的宽度
        sheight: 0,
        //被剪切图像的高度
        x: 0,
        //在画布上放置图像的 x 坐标位置
        y: 0,
        //在画布上放置图像的 y 坐标位置
        width: 0,
        //要使用的图像的宽度
        height: 0 //要使用的图像的高度
      },
      toolBox: {
        disable: true,
        width: toolBoxWidth,
        height: toolBoxHeight,
        x: 0,
        y: 0,
        boxMove: {
          start: {
            x: 0,
            y: 0
          },
          moveTo: {
            x: 0,
            y: 0
          }
        }
      },
      dropImg: {
        active: false,
        pageX: 0,
        pageY: 0,
        params: {}
      },
      // 旋转
      rotateImg: {
        angle: 0
      },
      rotateControl: {
        active: false,
        start: {
          x: 0,
          y: 0
        },
        position: 100
      },
      // 缩放
      scaleImg: {
        rate: 0,
        params: {}
      },
      controlBox: {
        disable: true,
        btnName: "",
        start: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        }
      },
      selectBox: false,
      selectBoxColor: "rgba(0,0,0,0.6)",
      isFlipHorizontal: false,
      //是否水平翻转
      isFlipVertically: false // 是否垂直翻转
    };
  },
  watch: {
    isModal: {
      handler(bool) {
        console.log("boool", bool);
        this.popFunc(bool, this);
      },
      deep: true
    }
  },
  methods: {
    isPhone() {
      const sUserAgent = navigator.userAgent.toLowerCase();
      return /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent);
    },
    handleOpen() {
      this.chooseImg();
    },
    handleOpenPop(img) {
      let init = callback => {
        if (!this.isMobile) {
          if (this.$refs["toolBox"]) {
            this.$refs["toolBox"].onmousewheel = this.scaleImgWheel;
            this.$refs["toolBox"].addEventListener("DOMMouseScroll", this.scaleImgWheel);
          }
        } else {
          this.$refs["toolBox"].addEventListener("touchstart", this.scaleImgWheelTouchMoveWap, {
            passive: false
          });
          this.$refs["toolBox"].addEventListener("touchmove", this.scaleImgWheelTouchMoveWap, {
            passive: false
          });
        }
      };
      this.$emit("update:isModal", true);
      this.$nextTick(() => {
        init();
      });
    },
    handleClose() {
      this.clearAll();
      this.$emit("update:isModal", false);
      this.$parent.upImgLoading = false;
    },
    // 选择图片 e.stopPropagation();
    chooseImg() {
      this.$refs["inputFile"].click();
    },
    ...walletVuex.mapActions(["doConnect"]),
    ...userVuex.mapActions(["getLoginInfo", "upLoadImg"]),
    async uploadGif(e) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const fn = async () => {
        const res = await this.upLoadImg(e.target.files[0]);
        if (!res) {
          this.$parent.upImgLoading = false;
          return;
        }
        return res;
      };
      if (this.isConnect === "connected" && !this.userInfo) {
        await this.getLoginInfo([]);
      }
      if (this.userInfo?.auth_token) {
        const res = await fn();
        if (res && res.code === 0) {
          this.$emit("cutDown", {
            fileName: null,
            dataURL: null,
            requireUrl: res.data
          });
        }
      } else {
        this.$parent.upImgLoading = false;
        this.$refs["inputFile"].value = "";
        this.$toasted.info(this.$lang("You need to connect to your wallet before uploading gif!"));
        this.doConnect();
      }
    },
    putImgBlur(e) {},
    // 将选择的图片绘制到画布

    async putImgToCanv(e) {
      this.$parent.upImgLoading = true;
      if (this.$refs?.inputFile) {
        this.$parent.form.tokenIcon = null;
      }
      let file;
      if (e.target.files) {
        file = e.target.files[0] || null;
      } else {
        // 如果是IE9及以下
        this.$parent.upImgLoading = false;
        console.error("IE9 and below need to pass in the image object themselves");
        // this.$emit('importImage',e);
        return false;
      }
      if (file) {
        this.fileName = file.name;
        this.fileType = file.type.split("/")[1];
        if (this.isConnect === "connected" && !this.userInfo) {
          await this.getLoginInfo([]);
        }
        console.log("this.userInfo", this.userInfo);
        if (!this.userInfo?.auth_token) {
          this.$parent.upImgLoading = false;
          this.$refs["inputFile"].value = "";
          this.$toasted.info(this.$lang("You need to connect to your wallet before uploading img!"));
          this.doConnect();
          return;
        }
        if (this.fileType === "gif") {
          await this.uploadGif(e);
          return;
        }
        this.handleOpenPop();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = result => {
          // 图片base64化
          let newUrl = result.target.result;
          let img = document.createElement("img");
          img.src = newUrl;
          let timmer = setInterval(() => {
            if (reader.readyState === 2) {
              clearInterval(timmer);
              if (!this.sizeChange && this.smallToUpload && img.width <= this.cutWidth && img.height <= this.cutHeight) {
                this.handleClose();
                file.name = this.changeFileName(file.name, this.fileType);
                this.$emit("cutDown", {
                  filename: this.changeFileName(file.name, this.fileType),
                  file: file,
                  requireUrl: null
                });
                return;
              }
              let imgHeight = img.height;
              let imgWidth = img.width;
              let boxWidth = this.boxWidth;
              let boxHeight = this.boxHeight;
              let rate;
              let drawImg = {
                ...this.drawImg
              };
              drawImg.img = img;
              this.scaleImg.rate = imgWidth / imgHeight; // 缩放时用到此参数
              console.log("imgHeight", imgHeight, boxHeight, imgWidth, boxWidth);
              if (imgHeight < boxHeight && imgWidth < boxWidth) {
                rate = 1;
                drawImg.x = (boxWidth - imgWidth) / 2;
                drawImg.y = (boxHeight - imgHeight) / 2;
              } else {
                if (imgWidth / imgHeight <= boxWidth / boxHeight) {
                  // 计算宽高比
                  rate = boxHeight / imgHeight;
                  drawImg.x = (boxWidth - imgWidth * rate) / 2;
                } else {
                  rate = boxWidth / imgWidth;
                  drawImg.y = (boxHeight - imgHeight * rate) / 2;
                }
              }
              const _ra = imgHeight / imgWidth;
              drawImg.swidth = imgWidth;
              drawImg.sheight = imgHeight;
              drawImg.width = this.cutWidth * rate;
              drawImg.height = this.cutWidth * _ra * rate;
              drawImg.x = (boxWidth - drawImg.width) / 2;
              drawImg.y = (boxHeight - drawImg.height) / 2;
              this.drawImg = drawImg;
              console.log("this.drawImg", this.drawImg);
              this.printImg();
              this.putToolBox();
            }
          }, 200);
        };
        this.$emit("onChooseImg", file, this.index);
      }
    },
    putToolBox() {
      if (this.toolBox.width === this.boxWidth / 2 || this.toolBox.height === this.boxHeight / 2 || this.saveCutPosition === false) {
        this.toolBox.width = this.cutWidth > this.boxWidth ? this.boxWidth : this.cutWidth;
        this.toolBox.height = this.cutHeight > this.boxHeight ? this.boxHeight : this.cutHeight;
      }
      if (this.toolBox.x === 0 && this.toolBox.y === 0 || this.saveCutPosition === false) {
        this.toolBox.x = this.boxWidth / 2 - this.toolBox.width / 2;
        this.toolBox.y = this.boxHeight / 2 - this.toolBox.height / 2;
      }
      this.checkToolBoxOverflow().then(() => {
        this.printImg();
      });
      this.drawControlBox(this.toolBox.width, this.toolBox.height, this.toolBox.x, this.toolBox.y);
    },
    // 判断裁剪框是否超出图片
    checkToolBoxOverflow() {
      return new Promise(resolve => {
        if (!this.toolBoxOverflow) {
          // 如果裁剪框不能超出图片 则先判断图片尺寸
          // 如果图片尺寸长宽都超过裁剪框 不做处理
          // 如果图片尺寸小于裁剪框 将图片缩放至合适尺寸
          if (this.drawImg.width < this.toolBox.width || this.drawImg.height < this.toolBox.height) {
            const p = this.drawImg.width / this.drawImg.height;
            if (this.drawImg.width < this.toolBox.width) {
              this.drawImg.width = this.toolBox.width;
              this.drawImg.height = this.drawImg.width / p;
            }
            if (this.drawImg.height < this.toolBox.height) {
              this.drawImg.height = this.toolBox.height;
              this.drawImg.width = this.drawImg.height * p;
            }
            // 根据图片缩放重新调整位置
            this.drawImg.x = (this.boxWidth - this.drawImg.width) / 2;
            this.drawImg.y = (this.boxHeight - this.drawImg.height) / 2;
          }
          // 检查图片坐标是否超出
          // console.log("this.drawImg.y > this.toolBox.y", this.drawImg.y + this.drawImg.height, this.toolBox.y + this.toolBox.height);
          // 判断左右边界
          if (this.drawImg.x > this.toolBox.x) {
            this.drawImg.x = this.toolBox.x;
          }
          if (this.drawImg.x + this.drawImg.width < this.toolBox.x + this.toolBox.width) {
            this.drawImg.x = this.toolBox.x + this.toolBox.width - this.drawImg.width;
          }
          // 判断上下边界
          if (this.drawImg.y > this.toolBox.y) {
            this.drawImg.y = this.toolBox.y;
          }
          if (this.drawImg.y + this.drawImg.height < this.toolBox.y + this.toolBox.height) {
            this.drawImg.y = this.toolBox.y + this.toolBox.height - this.drawImg.height;
          }
        }
        resolve();
      });
    },
    isSupportFileApi() {
      if (window.File && window.FileList && window.FileReader && window.Blob && navigator.userAgent.indexOf("Edge") === -1 && navigator.userAgent.indexOf("MSIE") === -1 && navigator.userAgent.indexOf("Trident") === -1) {
        return true;
      }
      return false;
    },
    disableScroll(event) {
      event.preventDefault();
    },
    // enableScroll() {
    //   document.body.removeEventListener("touchmove", preventDefault);
    // },
    dataURLtoFile(dataurl, filename) {
      //将图片转换为Base64
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      if (this.isSupportFileApi()) {
        let file = new File([u8arr], filename, {
          type: mime
        });
        return file;
      }
      return "不支持File对象";
    },
    // clear both
    clearAll() {
      let _this = this;
      let c = _this.$refs["canvas"];
      let ctx = c.getContext("2d");
      ctx.clearRect(0, 0, c.width, c.height);
      let c1 = _this.$refs["canvasSelectBox"];
      let ctx1 = c1.getContext("2d");
      ctx1.clearRect(0, 0, c1.width, c1.height);
      let sx = _this.drawImg.sx;
      let sy = _this.drawImg.sy;
      this.drawImg = {
        img: null,
        //规定要使用的图像、画布或视频
        sx: sx,
        //开始剪切的 x 坐标位置
        sy: sy,
        //开始剪切的 y 坐标位置
        swidth: 0,
        //被剪切图像的宽度
        sheight: 0,
        //被剪切图像的高度
        x: 0,
        //在画布上放置图像的 x 坐标位置
        y: 0,
        //在画布上放置图像的 y 坐标位置
        width: 0,
        //要使用的图像的宽度
        height: 0 //要使用的图像的高度
      };
      this.isFlipHorizontal = false;
      this.isFlipVertically = false;
      this.$refs["inputFile"].value = "";
      this.rotateImg.angle = 0;
      this.drawImg.img = null;
      this.turnReset();
      this.clearCutImageObj();
      this.$emit("onClearAll", this.index);
    },
    clearCutImageObj() {
      if (this.cutImageObj !== null && this.cutImageObj !== undefined) {
        if (typeof this.cutImageObj.remove === "function") {
          this.cutImageObj.remove();
        } else {
          this.cutImageObj.removeNode();
        }
      }
      this.cutImageObj = null;
    },
    // draw control
    drawControlBox(width, height, x, y) {
      // 裁剪框是否能够超出图片
      if (!this.toolBoxOverflow) {
        // 如果不允许超出图片范围 则也不允许反选
        if (width < 1) {
          width = 1;
        }
        if (height < 1) {
          height = 1;
        }
        if (width > this.drawImg.width) {
          width = this.drawImg.width;
        }
        if (height > this.drawImg.height) {
          height = this.drawImg.height;
        }
        if (x < this.drawImg.x) {
          x = this.drawImg.x;
        }
        if (y < this.drawImg.y) {
          y = this.drawImg.y;
        }
        if (x > this.drawImg.x + this.drawImg.width - width) {
          x = this.drawImg.x + this.drawImg.width - width;
        }
        if (y > this.drawImg.y + this.drawImg.height - height) {
          y = this.drawImg.y + this.drawImg.height - height;
        }
      }
      // 阻止超出裁剪控件边界
      if (width > this.boxWidth) {
        width = this.boxWidth;
      }
      if (height > this.boxHeight) {
        height = this.boxHeight;
      }
      if (x < 0) {
        x = 0;
      }
      if (y < 0) {
        y = 0;
      }
      let $toolBoxControl = this.$refs["toolBoxControl"];
      let c = this.$refs["canvasSelectBox"];
      let ctx = c.getContext("2d");
      ctx.fillStyle = this.selectBoxColor;
      ctx.clearRect(0, 0, c.width, c.height);
      ctx.fillRect(0, 0, c.width, c.height);
      let toolBoxControlWidth, toolBoxControlHeight;
      if (this.rate && this.rate !== "") {
        let p = this.rate.split(":")[0] / this.rate.split(":")[1];
        if (p >= 1) {
          toolBoxControlWidth = width;
          toolBoxControlHeight = width / p;
          if (toolBoxControlHeight + y > this.drawImg.y + this.drawImg.height) {
            toolBoxControlHeight = this.drawImg.y + this.drawImg.height - y;
            toolBoxControlWidth = toolBoxControlHeight * p;
          }
        } else {
          toolBoxControlWidth = height * p;
          toolBoxControlHeight = height;
        }
      } else {
        toolBoxControlWidth = width;
        toolBoxControlHeight = height;
      }
      this.toolBox.width = Math.abs(toolBoxControlWidth);
      this.toolBox.height = Math.abs(toolBoxControlHeight);
      $toolBoxControl.style.width = this.remTran(Math.abs(toolBoxControlWidth));
      $toolBoxControl.style.height = this.remTran(Math.abs(toolBoxControlHeight));
      this.toolBox.boxMove.moveTo.x = x;
      this.toolBox.boxMove.moveTo.y = y;
      if (toolBoxControlWidth < 0) {
        x = x + toolBoxControlWidth;
      }
      if (toolBoxControlHeight < 0) {
        y = y + toolBoxControlHeight;
      }
      if (x + this.toolBox.width > this.boxWidth) {
        x = this.boxWidth - this.toolBox.width;
      }
      if (x < 0) {
        x = 0;
      }
      if (y + this.toolBox.height > this.boxHeight) {
        y = this.boxHeight - this.toolBox.height;
      }
      if (y < 0) {
        y = 0;
      }
      this.toolBoxPosition.x = x;
      this.toolBoxPosition.y = y;
      $toolBoxControl.style.left = x + "px";
      $toolBoxControl.style.top = y + "px";
      ctx.clearRect(x, y, Math.abs(toolBoxControlWidth), Math.abs(toolBoxControlHeight));
      if (this.onPrintImgTimmer) {
        clearTimeout(this.onPrintImgTimmer);
      }
      this.onPrintImgTimmer = setTimeout(() => {
        this.cropPicture(true);
      }, 100);
    },
    resetToolBox() {
      if (this.toolBox.width < 0) {
        this.toolBox.boxMove.moveTo.x = this.toolBox.x - this.toolBox.width;
      }
      if (this.toolBox.height < 0) {
        this.toolBox.boxMove.moveTo.y = this.toolBox.y - this.toolBox.height;
      }
      this.toolBox.width = Math.abs(this.toolBox.width);
      this.toolBox.height = Math.abs(this.toolBox.height);
    },
    // toolBoxMouseDown
    toolBoxMouseDown(e) {
      if (this.isMobile && e.touches.length >= 2) {
        return;
      }
      let $toolBox = this.$refs["toolBoxControl"];
      this.toolBox.x = parseInt($toolBox.style.left.split("px")[0]);
      this.toolBox.y = parseInt($toolBox.style.top.split("px")[0]);
      this.toolBox.disable = false;
      this.dropImg.active = false;
      this.toolBox.boxMove.start = {
        x: e.pageX || e.touches[0].pageX,
        y: e.pageY || e.touches[0].pageY
      };
    },
    toolBoxMouseMove(e) {
      console.log(" e.touches.length6666", e.touches.length);
      if (this.isMobile && e.touches.length >= 2) {
        return;
      }
      if (this.dropImg.active) {
        this.dropImgMove(e);
      }
      if (this.toolBox.disable === false && this.moveAble === true) {
        let offsetX = (e.pageX || e.touches[0].pageX) - this.toolBox.boxMove.start.x;
        let offsetY = (e.pageY || e.touches[0].pageY) - this.toolBox.boxMove.start.y;
        let x = this.toolBox.x + offsetX;
        let y = this.toolBox.y + offsetY;
        this.drawControlBox(this.toolBox.width, this.toolBox.height, x, y);
      }
    },
    toolBoxMouseLeave() {
      this.toolBox.disable = true;
      if (this.onPrintImgTimmer) {
        clearTimeout(this.onPrintImgTimmer);
      }
      this.onPrintImgTimmer = setTimeout(() => {
        this.cropPicture(true);
      }, 100);
      this.resetToolBox();
    },
    toolBoxMouseUp() {
      this.toolBox.x = parseInt(this.toolBoxPosition.x);
      this.toolBox.y = parseInt(this.toolBoxPosition.y);
      this.toolBox.disable = true;
      this.dropImg.active = false;
      this.resetToolBox();
    },
    // 绘制图片
    printImg() {
      if (this.drawImg.img) {
        let canv = this.$refs["canvas"];
        let ctx = canv.getContext("2d");

        // 文字水印
        ctx.font = "18px bold 黑体";
        ctx.fillStyle = "#ff0";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.save();
        ctx.clearRect(0, 0, canv.width, canv.height);
        ctx.translate(this.drawImg.x + this.drawImg.width / 2, this.drawImg.y + this.drawImg.height / 2);
        ctx.rotate(this.rotateImg.angle * Math.PI / 180);
        ctx.translate(-(this.drawImg.x + this.drawImg.width / 2), -(this.drawImg.y + this.drawImg.height / 2));
        ctx.translate(this.drawImg.x, this.drawImg.y);
        ctx.scale(this.isFlipHorizontal ? -1 : 1, this.isFlipVertically ? -1 : 1);
        ctx.drawImage(this.drawImg.img, this.drawImg.sx, this.drawImg.sy, this.drawImg.swidth, this.drawImg.sheight, this.isFlipHorizontal ? -this.drawImg.width : 0, this.isFlipVertically ? -this.drawImg.height : 0, this.drawImg.width, this.drawImg.height);
        ctx.translate(-this.drawImg.x, this.drawImg.y);
        ctx.restore();
        if (this.onPrintImgTimmer) {
          clearTimeout(this.onPrintImgTimmer);
        }
        this.onPrintImgTimmer = setTimeout(() => {
          this.cropPicture(true);
        }, 100);
      }
    },
    // 拖动图片
    dropImgOn(e) {
      if (this.imgMove === true) {
        this.dropImg.active = true;
        this.dropImg.params = {
          ...this.drawImg
        };
        this.dropImg.pageX = e.pageX || e.touches[0].pageX;
        this.dropImg.pageY = e.pageY || e.touches[0].pageY;
      }
    },
    dropImgOff() {
      this.dropImg.active = false;
      if (this.onPrintImgTimmer) {
        clearTimeout(this.onPrintImgTimmer);
      }
      this.onPrintImgTimmer = setTimeout(() => {
        this.cropPicture(true);
      }, 100);
    },
    dropImgMove(e) {
      if (this.dropImg.active && this.drawImg.img) {
        let drawImg = {
          ...this.drawImg
        };
        drawImg.x = this.dropImg.params.x - (this.dropImg.pageX - (e.pageX || e.touches[0].pageX));
        drawImg.y = this.dropImg.params.y - (this.dropImg.pageY - (e.pageY || e.touches[0].pageY));
        // 裁剪框是否能够超出图片
        if (!this.toolBoxOverflow) {
          if (drawImg.x > this.toolBox.x) {
            drawImg.x = this.toolBox.x;
          }
          if (drawImg.x < this.toolBox.x + this.toolBox.width - drawImg.width) {
            drawImg.x = this.toolBox.x + this.toolBox.width - drawImg.width;
          }
          if (drawImg.y > this.toolBox.y) {
            drawImg.y = this.toolBox.y;
          }
          if (drawImg.y < this.toolBox.y + this.toolBox.height - drawImg.height) {
            drawImg.y = this.toolBox.y + this.toolBox.height - drawImg.height;
          }
        }
        // this.$set(this, 'drawImg', drawImg);
        this.drawImg = drawImg;
        this.printImg();
        e.stopPropagation();
      }
    },
    onZoom(scale) {
      const ratio = this.drawImg.height / this.drawImg.width;
      // console.log("ratio", ratio);
      this.drawImg.width = Number(this.drawImg.width) + scale;
      this.drawImg.height = Number(this.drawImg.height) + scale * ratio;
      // console.log("this.drawImg.width", this.drawImg.width, this.drawImg.height);
      this.printImg();
    },
    // 缩放
    scaleReset() {
      this.drawImg.width = this.drawImg.swidth;
      this.drawImg.height = this.drawImg.sheight;
      this.printImg();
    },
    getDistance(touch1, touch2) {
      const dx = touch2.pageX - touch1.pageX;
      const dy = touch2.pageY - touch1.pageY;
      return Math.sqrt(dx * dx + dy * dy); // 欧几里得距离
    },
    scaleImgWheelFnc(scale) {
      let widthLimit = 50;
      this.drawImg.x = this.drawImg.width - scale * 9 > widthLimit ? this.drawImg.x + scale * 3 : this.drawImg.x;
      this.drawImg.y = this.drawImg.width - scale * 9 > widthLimit ? this.drawImg.y + scale * 3 : this.drawImg.y;
      this.drawImg.width = this.drawImg.width - scale * 9 > widthLimit ? this.drawImg.width - scale * 9 : widthLimit;
      this.drawImg.height = this.drawImg.width / this.scaleImg.rate;
      this.checkToolBoxOverflow().then(() => {
        this.printImg();
        if (this.onPrintImgTimmer) {
          clearTimeout(this.onPrintImgTimmer);
        }
        this.onPrintImgTimmer = setTimeout(() => {
          this.cropPicture(true);
        }, 100);
      });
    },
    scaleImgWheel(e) {
      if (this.drawImg.img && this.scaleAble === true) {
        let scale;

        // e是FF的事件。window.event是chrome/ie/opera的事件
        let ee = e || window.event;
        if (ee.wheelDelta) {
          //IE/Opera/Chrome
          scale = -(ee.wheelDelta / 40);
        } else if (ee.detail) {
          //Firefox
          scale = ee.detail;
        }
        this.scaleImgWheelFnc(scale);
      }
      // let scrollTop = this.$refs['mask'].scrollTop;
      // window.scrollTo(this.$refs['mask'].scrollLeft,scrollTop);
      e.preventDefault();
      e.returnValue = false;
      return false;
    },
    // 水平翻转
    flipHorizontal() {
      if (this.drawImg.img) {
        if (this.isFlipHorizontal == false) {
          this.isFlipHorizontal = true;
        } else {
          this.isFlipHorizontal = false;
        }
        this.printImg();
      }
    },
    // 垂直翻转
    flipVertically() {
      if (this.drawImg.img) {
        if (this.isFlipVertically == false) {
          this.isFlipVertically = true;
        } else {
          this.isFlipVertically = false;
        }
        this.printImg();
      }
    },
    // 旋转
    turnImg(angle) {
      let startAngle = this.rotateImg.angle;
      let turnAngle = startAngle + angle;
      if (turnAngle >= -180 && turnAngle <= 180) {
        this.rotateImg.angle = turnAngle;
        this.rotateControl.position = turnAngle / 180 * 100 + 100;
        this.printImg("rotate");
      }
    },
    turnReset() {
      this.rotateImg.angle = 0;
      this.rotateControl.position = 100;
      this.printImg("rotate");
    },
    // control box
    controlBtnMouseDown(e, btnName) {
      this.controlBox.disable = false;
      this.controlBox.btnName = btnName;
      this.controlBox.start.x = e.clientX;
      this.controlBox.start.y = e.clientY;
      this.controlBox.start.width = this.toolBox.width;
      this.controlBox.start.height = this.toolBox.height;
      e.stopPropagation();
    },
    controlBtnMouseUp(e) {
      this.controlBox.disable = true;
      this.dropImgOff();
      this.resetToolBox();
      this.toolBoxMouseUp();
      e.stopPropagation();
    },
    controlBtnMouseMove(e) {
      if (this.controlBox.disable === false) {
        let offsetX = e.clientX - this.controlBox.start.x;
        let offsetY = e.clientY - this.controlBox.start.y;
        let x, y;
        if (this.controlBox.btnName == "leftUp") {
          if (!this.rate) {
            x = this.toolBox.x + offsetX;
            y = this.toolBox.y + offsetY;
          } else {
            let p = this.rate.split(":")[0] / this.rate.split(":")[1];
            if (p >= 1) {
              x = this.toolBox.x + offsetX;
              y = this.toolBox.y + offsetX / p;
            } else {
              x = this.toolBox.x + offsetY * p;
              y = this.toolBox.y + offsetY;
            }
          }
          this.toolBox.width = this.controlBox.start.width - offsetX;
          this.toolBox.height = this.controlBox.start.height - offsetY;
        }
        if (this.controlBox.btnName == "rightUp") {
          if (!this.rate) {
            x = this.toolBox.x;
            y = this.toolBox.y + offsetY;
          } else {
            let p = this.rate.split(":")[0] / this.rate.split(":")[1];
            if (p >= 1) {
              x = this.toolBox.x;
              y = this.toolBox.y - offsetX / p;
            } else {
              x = this.toolBox.x;
              y = this.toolBox.y + offsetY;
            }
          }
          this.toolBox.width = this.controlBox.start.width + offsetX;
          this.toolBox.height = this.controlBox.start.height - offsetY;
        }
        if (this.controlBox.btnName == "rightDown") {
          x = this.toolBox.x;
          y = this.toolBox.y;
          this.toolBox.width = this.controlBox.start.width + offsetX;
          this.toolBox.height = this.controlBox.start.height + offsetY;
        }
        if (this.controlBox.btnName == "leftDown") {
          if (!this.rate) {
            x = this.toolBox.x + offsetX;
            y = this.toolBox.y;
          } else {
            let p = this.rate.split(":")[0] / this.rate.split(":")[1];
            if (p >= 1) {
              x = this.toolBox.x + offsetX;
              y = this.toolBox.y;
            } else {
              x = this.toolBox.x + -offsetY * p;
              y = this.toolBox.y;
            }
          }
          this.toolBox.width = this.controlBox.start.width - offsetX;
          this.toolBox.height = this.controlBox.start.height + offsetY;
        }
        if (this.controlBox.btnName == "topCenter") {
          x = this.toolBox.x;
          y = this.toolBox.y + offsetY;
          this.toolBox.width = this.controlBox.start.width;
          this.toolBox.height = this.controlBox.start.height - offsetY;
        }
        if (this.controlBox.btnName == "downCenter") {
          x = this.toolBox.x;
          y = this.toolBox.y;
          this.toolBox.width = this.controlBox.start.width;
          this.toolBox.height = this.controlBox.start.height + offsetY;
        }
        if (this.controlBox.btnName == "leftCenter") {
          x = this.toolBox.x + offsetX;
          y = this.toolBox.y;
          this.toolBox.width = this.controlBox.start.width - offsetX;
          this.toolBox.height = this.controlBox.start.height;
        }
        if (this.controlBox.btnName == "rightCenter") {
          x = this.toolBox.x;
          y = this.toolBox.y;
          this.toolBox.width = this.controlBox.start.width + offsetX;
          this.toolBox.height = this.controlBox.start.height;
        }
        this.drawControlBox(this.toolBox.width, this.toolBox.height, x, y);
      }
      e.stopPropagation();
    },
    changeFileName(fileName, type) {
      let index = fileName.lastIndexOf(".");
      return fileName.substr(0, index + 1) + (type === "jpeg" ? "jpg" : type);
    },
    async cropPicture(doNotReset) {
      let _this = this;
      if (this.drawImg.img) {
        // get img
        let canvas = this.$refs["canvas"];

        // 文字水印
        if (this.WatermarkText && !doNotReset) {
          let ctx2 = canvas.getContext("2d");
          ctx2.font = this.WatermarkTextFont;
          ctx2.fillStyle = this.WatermarkTextColor;
          ctx2.textAlign = "right";
          ctx2.textBaseline = "bottom";
          ctx2.fillText(this.WatermarkText, this.toolBox.x + this.toolBox.width * this.WatermarkTextX, this.toolBox.y + this.toolBox.height * this.WatermarkTextY);
        }
        let tempImg = new Image();
        if (this.crossOrigin === true) {
          tempImg.crossOrigin = this.crossOriginHeader;
        }
        tempImg.src = await this.exportCanvas(canvas, this.fileType);
        if (!HTMLCanvasElement.prototype.toBlob) {
          Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
            value: (callback, type, quality) => {
              if (window.atob) {
                setTimeout(async () => {
                  let binStr = atob(await this.exportCanvas(canvas, this.fileType).split(",")[1]);
                  let len = binStr.length,
                    arr = new Uint8Array(len);
                  let NewBlob;
                  for (let i = 0; i < len; i++) {
                    arr[i] = binStr.charCodeAt(i);
                  }
                  try {
                    NewBlob = new Blob([arr], {
                      type: `image/${_this.fileType}`
                    });
                  } catch (e) {
                    window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
                    if (e.name == "TypeError" && window.BlobBuilder) {
                      const BlobBuilder = window.BlobBuilder;
                      let bb = new BlobBuilder();
                      bb.append(arr.buffer);
                      NewBlob = bb.getBlob(`image/${_this.fileType}`);
                    }
                    if (e.name == "InvalidStateError") {
                      NewBlob = new Blob([arr.buffer], {
                        type: `image/${_this.fileType}`
                      });
                    }
                  }
                  // TypeError old chrome and FF
                  callback(NewBlob);
                }, 200);
              } else {
                callback(false, {
                  type: `image/${_this.fileType}`
                });
              }
            }
          });
        }
        canvas.toBlob(async blob => {
          if (blob) {
            let reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = () => {
              let timmer = setInterval(async () => {
                if (reader.readyState == 2) {
                  clearInterval(timmer);
                  let newCanv = document.createElement("canvas");
                  let ctx = newCanv.getContext("2d");

                  // 原图裁剪 originalGraph
                  if (_this.originalGraph == true) {
                    let scale = _this.drawImg.width / _this.drawImg.swidth;

                    // 计算实际图像大小
                    let transWidth = _this.toolBox.width / scale;
                    let transHeight = _this.toolBox.height / scale;
                    newCanv.width = transWidth;
                    newCanv.height = transHeight;
                    // 重新计算裁剪坐标
                    let sx = (_this.toolBox.x - _this.drawImg.x) / scale;
                    let sy = (_this.toolBox.y - _this.drawImg.y) / scale;
                    let swidth = _this.drawImg.swidth;
                    let sheight = _this.drawImg.sheight;

                    // TODO 使原图裁剪支持旋转后的图像
                    // ctx.translate(sx + transWidth/2, sy + transHeight/2);
                    // ctx.rotate((_this.rotateImg.angle) * Math.PI / 180);
                    // ctx.translate(-(sx + transWidth/2), -(sy + transHeight/2));
                    ctx.translate(-sx, -sy);
                    ctx.drawImage(_this.drawImg.img, 0, 0, swidth, sheight);
                  } else {
                    newCanv.width = _this.toolBox.width;
                    newCanv.height = _this.toolBox.height;
                    let params = _this.toolBox;
                    if (_this.rate) {
                      let p = _this.rate.split(":")[0] / _this.rate.split(":")[1];
                      let m = _this.rate.split(":")[0];
                      let n = _this.rate.split(":")[1];
                      if (m >= n) {
                        ctx.drawImage(tempImg, params.x, params.y, params.width, params.width * p, 0, 0, params.width, params.width * p);
                      } else {
                        ctx.drawImage(tempImg, params.x, params.y, params.width, params.width / p, 0, 0, params.width, params.width / p);
                      }
                    } else {
                      ctx.drawImage(tempImg, params.x, params.y, params.width, params.height, 0, 0, params.width, params.height);
                    }
                  }
                  newCanv.toBlob(async newBlob => {
                    let fileName = _this.changeFileName(_this.fileName, _this.fileType);
                    if (!doNotReset) {
                      _this.handleClose();
                      _this.$emit("cutDown", {
                        file: _this.dataURLtoFile(await _this.exportCanvas(newCanv, _this.fileType), fileName),
                        dataURL: await _this.exportCanvas(newCanv, _this.fileType),
                        requireUrl: null
                      });
                    } else {
                      if (_this.previewMode) {
                        _this.$emit("onPrintImg", {
                          file: _this.dataURLtoFile(await _this.exportCanvas(newCanv, _this.fileType), fileName),
                          dataURL: await _this.exportCanvas(newCanv, _this.fileType),
                          requireUrl: null
                        });
                      }
                    }
                  }, `image/${_this.fileType}`, _this.quality);
                }
              }, 200);
            };
          } else {
            // IE9及以下
            let newCanv = document.createElement("canvas");
            newCanv.width = _this.toolBox.width;
            newCanv.height = _this.toolBox.height;
            let ctx = newCanv.getContext("2d");
            let params = _this.toolBox;
            if (_this.rate) {
              let p = _this.rate.split(":")[0] / _this.rate.split(":")[1];
              ctx.drawImage(tempImg, params.x, params.y, params.width, params.width * p, 0, 0, params.width, params.width * p);
            } else {
              ctx.drawImage(tempImg, params.x, params.y, params.width, params.height, 0, 0, params.width, params.height);
            }
            let fileName = _this.changeFileName(_this.fileName, _this.fileType);
            if (!doNotReset) {
              _this.handleClose();
              _this.$emit("cutDown", {
                fileName,
                dataURL: await _this.exportCanvas(newCanv, _this.fileType),
                requireUrl: null
              });
            } else {
              _this.$emit("onPrintImg", {
                fileName,
                dataURL: await _this.exportCanvas(newCanv, _this.fileType),
                requireUrl: null
              });
            }
          }
        }, `image/${_this.fileType}`, _this.quality);
      } else {
        if (!doNotReset) {
          console.warn("No picture selected");
          this.$parent.upImgLoading = false;
          _this.$emit("error", {
            err: 1,
            msg: "No picture selected"
          });
        }
      }
    },
    exportCanvas: (canvas, format = "png") => {
      return new Promise((resolve, reject) => {
        // 导出 PNG 或 JPG
        const mimeType = `image/${format}`;
        try {
          const dataUrl = canvas.toDataURL(mimeType);
          resolve(dataUrl); // 返回 Base64 数据 URL
        } catch (error) {
          this.$parent.upImgLoading = false;
          reject(error);
        }
      });
    },
    scrollBarControlMove(e) {
      if (this.rotateControl.active) {
        let offsetX = e.pageX - this.rotateControl.start.x;

        //                let rotate = this.rotateImg.angle/360*100 + offsetX/100*100;
        let position = this.rotateControl.start.position + offsetX;
        if (position <= 0) {
          position = 0;
        }
        if (position >= 200) {
          position = 200;
        }
        this.rotateControl.position = position;
        this.rotateImg.angle = (position - 100) / 100 * 180;
        this.printImg();
      }
    },
    scrollBarControlOn(e) {
      this.rotateControl.active = true;
      this.rotateControl.start.x = e.pageX;
      this.rotateControl.start.y = e.pageY;
      this.rotateControl.start.position = this.rotateControl.position;
    },
    scrollBarControlOff() {
      this.rotateControl.active = false;
    }
  },
  computed: {
    ...walletVuex.mapState(["isMobile", "isConnect"]),
    ...userVuex.mapState(["userInfo"]),
    boxHeight() {
      return this.isPhone() && this.isMobile ? 300 : 400;
    },
    boxWidth() {
      return this.isPhone() && this.isMobile ? 300 : 400;
    },
    showToolBoxWidth() {
      let result;
      if (!this.originalGraph) {
        result = this.toolBox.width;
      } else {
        result = this.toolBox.width / (this.drawImg.width / this.drawImg.swidth);
      }
      return Number(result).toFixed(0);
    },
    showToolBoxHeight() {
      let result;
      if (!this.originalGraph) {
        result = this.toolBox.height;
      } else {
        result = this.toolBox.height / (this.drawImg.width / this.drawImg.swidth);
      }
      return Number(result).toFixed(0);
    },
    showToolBoxX() {
      let result;
      result = this.toolBoxPosition.x;
      return Number(result).toFixed(0);
    },
    showToolBoxY() {
      let result;
      result = this.toolBoxPosition.y;
      return Number(result).toFixed(0);
    }
  }
};